import React from 'react';
import { Link } from 'react-router-dom';
import { includes, map } from 'lodash';

import {
    CategorizerTournamentMetaKey,
    OUTRIGHTS_ONLY_SPORTS,
} from 'app-constants';
import { GameLogo, SportFilterHeading } from 'components';
import {
    getSearchString,
    getSummaryPath,
    hasAnyMetaEventsInCategorizer,
} from '../../../utils';
import useSportsList from './useSportsList';

const SportsList: React.FC = () => {
    const { categorizerItems, handleLinkClick, sportId } = useSportsList();

    return (
        <React.Fragment>
            {map(categorizerItems, ({ value, name, meta }) => (
                <Link
                    key={value}
                    to={getLinkTo(value)}
                    onClick={handleLinkClick}
                    aria-disabled={true}
                >
                    <SportFilterHeading
                        isActive={value === sportId}
                        logo={<GameLogo gameId={value} />}
                        title={name}
                        isLive={hasAnyMetaEventsInCategorizer(
                            meta,
                            CategorizerTournamentMetaKey.LiveEventsCount
                        )}
                    />
                </Link>
            ))}
        </React.Fragment>
    );
};

export default React.memo(SportsList);

const getLinkTo = (value: string): { search: string; pathname?: string } => {
    if (includes(OUTRIGHTS_ONLY_SPORTS, value)) {
        return getSummaryPath(value);
    }

    return {
        search: getSearchString({
            sportId: value,
            tournamentId: undefined,
            tournamentIds: undefined,
        }),
    };
};
